export default "__VITE_ASSET__1e4e04d1__"